var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('h1',{staticClass:"title"},[_vm._v("\n    Your discover ebooks\n  ")]),_c('chunked-ebooks-display',{attrs:{"ebooks":_vm.discoverEbooks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }